import { render } from "./Grend1.vue?vue&type=template&id=f22b97a0&class=true&bindings={}"
import script from "./Grend1.vue?vue&type=script&lang=js"
export * from "./Grend1.vue?vue&type=script&lang=js"

import "./Grend1.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script